import { type FC, type ReactNode, type ComponentClass } from 'react';

// styles
import styles from './PdpSharedBlurb.scss';

// helpers
import classnames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';

type Props = {
    iconClass?: string | null;
    IconComponent: FC | ComponentClass | null;
    printHide?: boolean;
    dataTn?: string;
    hideIcon?: boolean;
    zeroPadding?: boolean;
    zeroMargin?: boolean;
    title?: ReactNode;
    detail?: ReactNode;
    children?: ReactNode;
};

const BlurbContent: FC<{ title: ReactNode; detail: ReactNode }> = ({ title, detail }) => (
    <FormattedMessage
        id="PdpSharedBlurb.blurbContent"
        defaultMessage="<labelRef>{title}:</labelRef> {detail}"
        values={{
            title,
            labelRef: content => <span className={styles.blurbTitle}>{content}</span>,
            detail: <span className={styles.blurbDetail}>{detail}</span>,
        }}
    />
);

export const PdpSharedBlurb: FC<Props> = ({
    IconComponent,
    printHide,
    dataTn,
    iconClass,
    hideIcon,
    zeroPadding,
    zeroMargin,
    title,
    detail,
    children,
}) => (
    <div
        className={classnames(styles.wrapper, {
            [styles.printHide]: printHide,
            [styles.zeroMargin]: zeroMargin,
        })}
        data-tn={dataTn}
    >
        {IconComponent && !hideIcon && (
            <div className={classnames(styles.icon, iconClass)}>
                <IconComponent />
            </div>
        )}
        <div className={classnames(styles.text, { [styles.zeroPadding]: zeroPadding })}>
            {title && detail ? <BlurbContent title={title} detail={detail} /> : children}
        </div>
    </div>
);
